import React from "react";

export const VendorContext = React.createContext(null);
